import ProfilerAnswerError from './ProfilerAnswerError';
class AnswerIsNotAmong extends ProfilerAnswerError {
    constructor(options) {
        super('The answer is not among the allowed options', options);
    }
}
export default AnswerIsNotAmong;
